import { WlcmPlacesApi } from '@wlcm/angular/forms';
import { Observable, Subscriber } from 'rxjs';

export const getPlaceDetails = (
  placesApi: WlcmPlacesApi,
  placeId: string
): Observable<google.maps.places.PlaceResult | null> => {
  return new Observable((subscriber: Subscriber<google.maps.places.PlaceResult | null>) => {
    placesApi.placesService.getDetails({ placeId }, (result: google.maps.places.PlaceResult | null) => {
      subscriber.next(result);

      subscriber.complete();
    });
  });
};
